import {EnvType, GlobalConfig} from "../appConfig";

export const GetAPIHost = () => {
	if (GlobalConfig.envType === EnvType.dev) {
		return 'https://api-app.iclinichealth.dev'
	}else if (GlobalConfig.envType === EnvType.uat) {
		return 'https://api-app.iclinichealth.net'
	}else {
		return 'https://api-app.iclinichealth.com'
	}
};

export const GetAPIBaseURL = () => {
	return GetAPIHost() + API_Service.ezHealth
};

const API_Service = {
	ezHealth: '/ezhealth/',
};

export const API_TeletHealth = {
	addChatMessageToMongoDB: 'TeleHealth/AddChatMessageToMongoDB',
	saveAttachment: 'TeleHealth/SaveAttachment',
	addChatScreenShot: 'TeleHealth/AddChatScreenShot',
	getMeetingInfo: 'TeleHealth/GetMeetingInfo',
	loadChatRecords: 'TeleHealth/LoadChatRecords',
	loadAppointmentChatRecords: 'TeleHealth/LoadAppointmentChatRecords',
	pauseChat: 'TeleHealth/PauseChat',
	loadChatIDRecords: 'TeleHealth/LoadChatIDRecords',
	loadChatRecordsByDate: 'TeleHealth/LoadChatRecordsByDate',
	joinChatRoom: 'TeleHealth/JoinChatRoom',
	canJoinChatRoom: 'TeleHealth/CanJoinChatRoom',
	leaveChatRoom: 'TeleHealth/LeaveChatRoom',
	beginVideo: 'TeleHealth/BeginVideo',
	endVideo: 'TeleHealth/EndVideo',
	inviteToChat: 'TeleHealth/InviteToChat',
	checkIsWebVisit: 'TeleHealth/CheckIsWebVisit',
	getSignUpCode: 'SignUp/GetSignUpCode',
	invitePatientToChatBySMS: 'TeleHealth/InvitePatientToChatBySMS',
	startRecordingAudio: 'TeleHealth/StartRecordingAudio',
	stopRecording: 'TeleHealth/StopRecording',
	startRecordingVideo: 'TeleHealth/StartRecordingVideo',
	stopRecordingVideo: 'TeleHealth/StopRecordingVideo'
}

export const API_Utility = {
	appLogs: 'Utility/AppLogs',
}
